import { Pane, Text } from '@leverege/ui-elements';
import React from 'react';
import S from './VehicleDTCAlertsHistory.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function VehicleDTCAlertsHistory({
  value: rawDtcs
}) {
  const dtcs = JSON.parse(rawDtcs);
  if (!Array.isArray(dtcs) || dtcs?.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    className: S.dtcCardsContainer,
    children: dtcs.map(dtc => /*#__PURE__*/_jsxs(Pane, {
      variant: "card",
      className: S.dtcCard,
      children: [/*#__PURE__*/_jsxs(Text, {
        children: [/*#__PURE__*/_jsx("b", {
          children: "Code:"
        }), " ", dtc?.code, " | ", /*#__PURE__*/_jsx("b", {
          children: "Timestamp:"
        }), " ", dtc?.time]
      }), /*#__PURE__*/_jsxs(Text, {
        children: [/*#__PURE__*/_jsx("b", {
          children: "ECU:"
        }), " ", dtc?.ecu, " | ", /*#__PURE__*/_jsx("b", {
          children: "Description:"
        }), " ", dtc?.desc]
      })]
    }, dtc?.code))
  });
}